import React, { useContext, useState, useEffect, useRef } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { BsGlobe2 } from "react-icons/bs";
import { SetUserContext } from '../../Context/SetUserContext';
import registerUserAndCompny from "../../controller/api/RegisterUserAndCompany";
import './RegisterLeft.css';
import { GetUserContext } from '../../Context/GetUserContext';

const RegisterLeft = () => {
    const { size } = useContext(GetUserContext)
    const [load, setLoad] = useState(false)

    const userAndCompnay = new registerUserAndCompny();
    const {
        // Address
        city, setCity, state, setState, ibge, setIbge,
        cep, setCep, neighborhood, setNeighborhood,
        region, setRegion, street, setStreet,
        numberAddress, setNumberAddress,
        uf, setUf, complement, setComplement,
        emailCompany, setEmailCompany,
        // Company
        logo, setLogo, corporateName, setCorporateName,
        landline, setLandline, phone, setPhone,
        cnpj, setCnpj, webSite, setWebSite,
    } = useContext(SetUserContext);


    const handleSearchCep = () => {
        setLoad(true)
        userAndCompnay.seachByCep(cep)
            .then(response => {
                setCity(response.data?.localidade)
                setState(response.data?.estado)
                setIbge(response.data?.ibge)
                setNeighborhood(response.data?.bairro)
                setRegion(response.data?.regiao)
                setUf(response.data?.uf)
                setStreet(response.data?.logradouro)
                setComplement(response.data?.complemento)
                setLoad(false)
            })
            .catch(error => {
                console.error("Erro ao buscar CEP:", error);
            });
    }

    console.log(neighborhood)

    return (
        <Form className="form-horizontal">
            <div className='d-flex justify-content-between'>
                <div></div>
                <p><span className='text-danger'>* </span>Campo Obrigatório</p>
            </div>

            <div className='d-flex justify-content-between'>
                <div className='w-100'>
                    <div>Nome<span className='text-danger'>*</span></div>
                    <div><input onChange={(e) => { setCorporateName(e.target.value) }} className="form-control" type="text" /></div>
                </div>
            </div>

            <hr></hr>
            <div className=' d-flex justify-content-between'>
                <div className='w-100'>
                    <div>CNPJ<span className='text-danger'>*</span></div>
                    <div>
                        <input
                            name="cnpj"
                            value={cnpj}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                if (value.length <= 14) setCnpj(value);
                            }}
                            className="form-control"
                            maxLength={14}
                            type="text"
                            placeholder="Apenas números"
                        />

                    </div>
                </div>

                <div style={{ margin: "8px" }}></div>

                <div className='w-100'>
                    <div>Telefone<span className='text-danger'>*</span></div>
                    <InputGroup>
                        <InputGroup.Text>
                            <BsTelephoneFill />
                        </InputGroup.Text>
                        <input
                            name="telefone1"
                            value={landline}
                            onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '');
                                if (value.length <= 11) setLandline(value);
                            }}
                            className="form-control"
                            placeholder="XX XXXXX-XXXX"
                            required
                            maxLength={11}
                            type="text"
                        />
                    </InputGroup>
                </div>
            </div>
            <hr></hr>
            <div className='w-100'>
                <label className="col-md-2 control-label" htmlFor="email">
                    Email <span className='text-danger'>*</span>
                </label>
                <div className='w-100'>
                    <InputGroup>
                        <InputGroup.Text>
                            <MdEmail />
                        </InputGroup.Text>
                        <input
                            name="email"
                            onChange={(e) => { setEmailCompany(e.target.value) }}
                            className="form-control"
                            required
                            pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}"
                            placeholder="email@email.com"
                            type="text"
                        />

                    </InputGroup>
                </div>
            </div>
            <hr></hr>
            {
                size?.categoria === 'small' ?
                    (
                        <>
                            <div className="form-group">
                                <label className="control-label" htmlFor="cep">
                                    CEP <span className='text-danger'>*</span>
                                </label>

                                <div className='d-flex justify-content-between'>
                                    <div className="w-100">
                                        <input
                                            name="cep"
                                            value={cep}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, '');
                                                if (value.length <= 8) setCep(value);
                                            }}
                                            className="form-control input-md"
                                            required
                                            maxLength={8}
                                            pattern="[0-9]+"
                                            placeholder="Apenas números"
                                            type="text"
                                        />

                                    </div>
                                    <div style={{ margin: "8px" }}></div>
                                    {
                                        load ?
                                            (<Button onClick={handleSearchCep} type="button" className="btn btn-secondary w-50">...</Button>)
                                            :
                                            (<Button onClick={handleSearchCep} type="button" className="btn btn-secondary w-50">Pesquisar</Button>)
                                    }

                                </div>
                            </div>
                            <hr></hr>

                            <div>
                                <label style={{ marginRight: "5px" }} className="control-label"> Endereço: <span className='text-danger'> *</span>  </label>
                            </div>
                            <div className="form-group">
                                <div className='w-100'>
                                    <InputGroup>
                                        <input placeholder='Rua' defaultValue={street} onChange={(e) => { setStreet(e.target.value) }} name="email" className="form-control" type="text" />
                                    </InputGroup>
                                </div>
                                <div style={{ margin: "8px" }}></div>
                                <div className='w-100'>
                                    <InputGroup>
                                        <input placeholder='Bairro' defaultValue={neighborhood} onChange={(e) => { setNeighborhood(e.target.value) }} name="email" className="form-control" type="text" />
                                    </InputGroup>
                                </div>
                                <div style={{ margin: "8px" }}></div>
                                <div className='w-100'>
                                    <InputGroup>
                                        <input placeholder='Numero' onChange={(e) => { setNumberAddress(e.target.value) }} defaultValue={numberAddress} name="number" className="form-control" type="text" />
                                    </InputGroup>
                                </div>
                            </div>
                            <br></br>
                            <div className="form-group ">
                                <div className='w-100'>
                                    <InputGroup>
                                        <input placeholder='Complemento' onChange={(e) => { setComplement(e.target.value) }} defaultValue={complement} name="email" className="form-control" type="text" />
                                    </InputGroup>
                                </div>
                                <div style={{ margin: "8px" }}></div>
                                <div className='d-flex'>
                                    <div className='w-100'>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                Cidade
                                            </InputGroup.Text>
                                            <input defaultValue={city} disabled name="email" className="form-control" type="text" />
                                        </InputGroup>
                                    </div>
                                    <div style={{ margin: "8px" }}></div>
                                    <div className='w-50'>
                                        <InputGroup>
                                            <InputGroup.Text>
                                                UF
                                            </InputGroup.Text>
                                            <input defaultValue={uf} disabled name="number" className="form-control" type="text" />
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                    :
                    (<>
                        <div className="form-group">
                            <label className="control-label" htmlFor="cep">
                                CEP <span className='text-danger'>*</span>
                            </label>

                            <div className='d-flex justify-content-between'>
                                <div className="col-md-8">
                                    <input
                                        name="cep"
                                        value={cep}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            if (value.length <= 8) setCep(value);
                                        }}
                                        className="form-control input-md"
                                        required
                                        maxLength={8}
                                        pattern="[0-9]+"
                                        placeholder="Apenas números"
                                        type="text"
                                    />

                                </div>
                                <div style={{ margin: "8px" }}></div>
                                {
                                    load ?
                                        (<Button onClick={handleSearchCep} type="button" className="btn btn-secondary w-100">...</Button>)
                                        :
                                        (<Button onClick={handleSearchCep} type="button" className="btn btn-secondary w-100">Pesquisar</Button>)
                                }

                            </div>
                        </div>
                        <hr></hr>

                        <div>
                            <label style={{ marginRight: "5px" }} className="control-label"> Endereço: <span className='text-danger'> *</span>  </label>
                        </div>
                        <div className="form-group d-flex align-items-center">

                            <div className='w-100'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        Rua
                                    </InputGroup.Text>
                                    <input defaultValue={street}  onChange={(e) => { setStreet(e.target.value) }} name="email" className="form-control" type="text" />
                                </InputGroup>
                            </div>

                            <div style={{ margin: "8px" }}></div>

                            <div className='w-100'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        Bairro
                                    </InputGroup.Text>
                                    <input defaultValue={neighborhood} onChange={(e) => { setNeighborhood(e.target.value) }} name="email" className="form-control" type="text" />
                                </InputGroup>
                            </div>
                            <div style={{ margin: "8px" }}></div>
                            <div className='w-50'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        N°<span className='text-danger'>*</span>
                                    </InputGroup.Text>
                                    <input onChange={(e) => { setNumberAddress(e.target.value) }} defaultValue={numberAddress} name="number" className="form-control" type="text" />
                                </InputGroup>
                            </div>


                        </div>
                        <br></br>
                        <div className="form-group d-flex align-items-center">

                            <div className='w-100'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        Complemento
                                    </InputGroup.Text>
                                    <input onChange={(e) => { setComplement(e.target.value) }} defaultValue={complement} name="email" className="form-control" type="text" />
                                </InputGroup>
                            </div>

                            <div style={{ margin: "8px" }}></div>
                            <div className='w-100'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        Cidade
                                    </InputGroup.Text>
                                    <input defaultValue={city} disabled name="email" className="form-control" type="text" />
                                </InputGroup>
                            </div>

                            <div style={{ margin: "8px" }}></div>

                            <div className='w-50'>
                                <InputGroup>
                                    <InputGroup.Text>
                                        UF
                                    </InputGroup.Text>
                                    <input defaultValue={uf} disabled name="number" className="form-control" type="text" />
                                </InputGroup>
                            </div>
                        </div>
                    </>
                    )
            }

            <hr></hr>
            <div className='w-100'>
                <label className="col-md-2 control-label" htmlFor="email">
                    Website
                </label>
                <div className='w-100'>
                    <InputGroup>
                        <InputGroup.Text>
                            <BsGlobe2 />
                        </InputGroup.Text>
                        <input name="text" onChange={(e) => { setWebSite(e.target.value) }} className="form-control" placeholder="email@email.com" type="text" />
                    </InputGroup>
                </div>
            </div>
        </Form >
    )
}

export default RegisterLeft